<template>
  <div>
    <table
      class="mt-3 mb-1 table table-striped table-bordered table-sm"
      style="width:100%;font-size:.9rem;"
    >
      <thead>
        <tr>
          <th
            v-if="isOpen"
            class="align-middle text-center text-success cursor-pointer"
            rowspan="2"
            title="Aggiungi immobile"
            @click="apriForm()"
          >
            <font-awesome-icon
              icon="plus"
              class="cursor-pointer text-success"
            />
          </th>
          <th
            class="align-middle text-center pl-3"
            rowspan="2"
          >
            TITOLARE<br>(Cognome e nome)
          </th>
          <th
            class="align-middle text-center"
            rowspan="2"
          >
            UBICAZIONE<br>(Località e indirizzo)
          </th>
          <th
            class="align-middle text-center text-uppercase"
            rowspan="2"
          >
            Tipo<br>immobile
          </th>
          <th
            class="align-middle text-center text-uppercase"
            rowspan="2"
          >
            % Tit.
          </th>
          <th
            class="align-middle text-center text-uppercase"
            rowspan="2"
          >
            Superficie<br>utile
          </th>
          <th
            class="align-middle text-center text-uppercase"
            rowspan="2"
          >
            Cat.
          </th>
          <th
            class="align-middle text-center text-uppercase"
            rowspan="2"
          >
            Rendita
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(i,idx) in rows"
          :key="i.idx"
        >
          <td
            v-if="isOpen"
            class="align-middle text-center text-success"
            title="Modifica immobile"
            @click="apriForm(idx)"
          >
            <font-awesome-icon
              icon="pen"
              class="cursor-pointer text-success"
            />
          </td>
          <td class="align-middle text-left">
            {{ i.cognome }} {{ i.nome }}
          </td>
          <td class="align-middle text-left">
            {{ i.descrizioneComune }} ({{ i.provincia }}) - {{ i.indirizzo }}
          </td>
          <td class="align-middle text-center">
            {{ tipoImmobileOptions.find(z => z.value === i.tipoImmobile).text  }}
          </td>
          <td class="align-middle text-center">
            {{ i.percTitolarita }} %
          </td>
          <td class="align-middle text-center">
            {{ i.tipoImmobile === 'F' ? i.superficieUtile + ' mq' : ' - ' }}
          </td>
          <td class="align-middle text-center">
            {{ i.tipoImmobile === 'F' ? i.categoria : ' - '}}
          </td>
          <td class="align-middle text-right">
            {{ numeral(i.rendita || 0).format() }} €
          </td>
        </tr>
        <tr v-if="!rows || !rows.length">
          <td
            :colspan="!isOpen ? '9' : '10'"
            class="text-center font-italic"
          >
            Nessun immobile dichiarato
          </td>
        </tr>
      </tbody>
    </table>

    <immobile-modal ref="modal" />

  </div>
</template>

<script>
import numeral from 'numeral'
import ImmobileModal from '@/components/ImmobilePatrimonioModal'

export default {
  name: 'ImmobiliPatrimonioTable',
  components: {
    ImmobileModal
  },
  props: {
    item: { type: Object, required: true }
  },
  computed: {
    numeral () {
      return numeral
    },
    isOpen () {
      // return this.item.stato === 'A'
      // console.log('(Redditi) Se dichiarazione P o B: ', this.item.stato, this.item.stato === 'B' || this.item.stato === 'P')
      // return this.item.stato === 'B'
      return this.item.stato === 'B' || this.item.stato === 'P'
    },
    rows () {
      return this.item.immobili
    },
    tipoImmobileOptions () {
      return this.$store.state.options.tipoImmobile
    }
  },
  methods: {
    apriForm (idx) {
      // GM: prova per tabella vuota
      // if (!this.item.immobili) this.item.immobili = []
      // fine della prova
      this.$refs.modal.open({ item: this.item, idx })
    }
  }
}
</script>
